import { createContext, useContext } from 'react'
import type { FlowEditorContextValue } from './flowEditorContextTypes'

export const FlowEditorContext = createContext<FlowEditorContextValue | null>(null)

export function useFlowEditorContext(): FlowEditorContextValue {
  const ctx = useContext(FlowEditorContext)

  if (ctx === null) {
    throw new Error('useFlowEditorContext must be used within FlowEditorProvider')
  }

  return ctx
}
